module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtMjI0IDQxNkgyODhhMzIgMzIgMCAwIDAtMy43IDYzLjhMMjg4IDU0NGg0NDhhMzIgMzIgMCAwIDAgMy43LTYzLjhMNzM2IDQ4MHoiIGZpbGw9IiMwIiBwLWlkPSIzMDk1Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Subtract-filled.svg
// module id = EAsq
// module chunks = 75